export const PartnerPlanTypes = Object.freeze({
  BASIC: 'Basic',
  PRO: 'Pro',
  EXPERT: 'Expert',
})

export const PartnerPlans = {
  [PartnerPlanTypes.BASIC]: {
    key: PartnerPlanTypes.BASIC,
    label: 'Basic',
    showReviews: false,
    showUsps: false,
    showPlan: false,
  },
  [PartnerPlanTypes.PRO]: {
    key: PartnerPlanTypes.PRO,
    label: 'Pro',
    showReviews: true,
    showUsps: true,
    showPlan: true,
  },
  [PartnerPlanTypes.EXPERT]: {
    key: PartnerPlanTypes.EXPERT,
    label: 'Expert',
    showReviews: true,
    showUsps: true,
    showPlan: true,
  },
}

export default {
  methods: {
    /**
     * @param {string} plan
     * @returns {object}
     */
    getPartnerPlan(plan) {
      return PartnerPlans[plan] ?? PartnerPlans[PartnerPlanTypes.BASIC]
    },
  },
}
